export default __webpack_public_path__ + "static/media/4.0e67d2f5.jpg";